/*=========================================================================================
  File Name: getters.js
  Description: Category Getters
  ----------------------------------------------------------------------------------------
  Item Name: Category State Module
  Author: Tan Tran
==========================================================================================*/

export default {
    firstCategory: state => {
        
        let count = state.categories.length;

        if (count > 0) {
            return state.categories[0].categoryId;
        }
        return null;
    }

   
}